import React from "react";
import { Grid } from "@mui/material";

export default function ModalBlankLine( ) {
    return <Grid item xs={12}>
        <br />
    </Grid>
}